import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./App.css";

import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "./i18n";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Terms from "./pages/Terms";
import ThankYou from "./pages/ThankYou";
import ScrollToTop from "./components/common/ScrollToTop";
import CookieBanner from "./components/CookieBanner";

// Language guard - syncs i18n with URL param
const LangGate = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!SUPPORTED_LANGUAGES.includes(lang)) return;
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    document.documentElement.lang = lang === "pe" ? "es-PE" : "en";
  }, [lang, i18n]);

  if (!SUPPORTED_LANGUAGES.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANGUAGE}`} replace />;
  }
  return <Layout />;
};

// Force Spanish for thank-you page regardless of previous language
const ThankYouWrapper = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (i18n.language !== "pe") i18n.changeLanguage("pe");
    document.documentElement.lang = "es-PE";
  }, [i18n]);
  return <ThankYou />;
};

// Redirect legacy /home -> /pe, catch-all -> /pe
const RootRedirect = () => {
  const location = useLocation();
  return (
    <Navigate to={`/${DEFAULT_LANGUAGE}${location.search}${location.hash}`} replace />
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/thank_you" element={<ThankYouWrapper />} />
        <Route path="/:lang" element={<LangGate />}>
          <Route index element={<Home />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="cookies" element={<Cookies />} />
          <Route path="terms" element={<Terms />} />
        </Route>
        <Route path="*" element={<Navigate to={`/${DEFAULT_LANGUAGE}`} replace />} />
      </Routes>
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
